'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _store = require('linksoft/core/store');

var _store2 = _interopRequireDefault(_store);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message2 = require('linksoft/message');

var _message3 = _interopRequireDefault(_message2);

var _cookie = require('linksoft/utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _utils = require('./cart/components/utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var common = {
    createElement: function createElement(tagName, parentElement, params) {
        // Create element helper, to simplify this process
        if (!tagName || !parentElement) return null;

        var element = document.createElement(tagName);
        if (params) {
            (0, _assign2.default)(element, params);
        }
        parentElement.appendChild(element);
        return element;
    },
    getCartData: function getCartData() {
        try {
            var storeData = _store2.default.get();
            return storeData.getState().cart;
        } catch (e) {
            console.error('Cart state was not loaded.', e);
            return null;
        }
    },
    sortByStringParam: function sortByStringParam(array, paramName) {
        var collator = Intl.Collator();

        return array.sort(function (a, b) {
            return collator.compare(a[paramName], b[paramName]);
        });
    },
    replaceDiacriticsCharacters: function replaceDiacriticsCharacters(inputString) {
        var diacriticsChars = "áäčďéěíĺľňóôőöŕšťúůűüýřžÁÄČĎÉĚÍĹĽŇÓÔŐÖŔŠŤÚŮŰÜÝŘŽ";
        var replacements = "aacdeeillnoooorstuuuuyrzAACDEEILLNOOOORSTUUUUYRZ";
        var result = '';
        for (var p = 0; p < inputString.length; p++) {
            var currentChar = inputString.charAt(p);
            var charIndex = diacriticsChars.indexOf(currentChar);
            result += charIndex !== -1 ? replacements.charAt(charIndex) : currentChar;
        }
        return result;
    },
    showMessageOrNotify: function showMessageOrNotify(severity, showAsPopup, title, messageText, options) {
        switch (severity.toLowerCase()) {
            case 'warn':
            case 'warning':
                if (showAsPopup) _message3.default.warn(messageText, title, options);else _notify2.default.warn(messageText, title, options);
            case 'err':
            case 'error':
            default:
                if (showAsPopup) _message3.default.error(messageText, title, options);else _notify2.default.error(messageText, title, options);
        }
    },

    batchReplace: function batchReplace(originalText, replacementObject) {
        if (!originalText || !replacementObject || !Array.isArray(replacementObject)) return originalText;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(replacementObject), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var replacement = _step.value;

                originalText = originalText.replaceAll(replacement.original, replacement.replacement);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return originalText;
    },

    getCookieConsent: function getCookieConsent() {
        var cookieConsentValue = _cookie2.default.getCookie("CookieConsent");
        var defaultObject = {
            stamp: 'NA',
            necessary: false,
            preferences: false,
            statistics: false,
            marketing: false,
            ver: 1,
            utc: new Date().getTime(),
            region: _utils2.default.skEnvironment() ? 'sk' : 'cz'
        };

        return common.decodeConsentCookieValue(cookieConsentValue, defaultObject);
    },

    decodeConsentCookieValue: function decodeConsentCookieValue(cookieConsentValue, defaultObject) {
        if (!cookieConsentValue) {
            return defaultObject;
        }
        try {
            var decodedValue = decodeURIComponent(cookieConsentValue).replace(/['"]?stamp['"]?\s?:\s*['"][^'"]+['"]\s*,?/, '').replace(/(['"])?([a-zA-Z0-9_=/]+)(['"])?/g, '"$2"');
            return JSON.parse(decodedValue);
        } catch (e) {
            console.error('Error in parsing CookieConsent cookie value', e);
            return defaultObject;
        }
    },

    hasMarketingConsent: function hasMarketingConsent() {
        return common.getCookieConsent().marketing === 'true';
    },
    hasStatisticsConsent: function hasStatisticsConsent() {
        return common.getCookieConsent().statistics === 'true';
    },
    getElementPropertySafe: function getElementPropertySafe(selector) {
        var propertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';

        var element = document.querySelector(selector);
        return element ? element[propertyName] : null;
    },
    setElementPropertySafe: function setElementPropertySafe(selector) {
        var propertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
        var propertyValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        var element = document.querySelector(selector);
        if (!element) return null;
        element[propertyName] = propertyValue;
        return element;
    },
    setElementDatasetValueSafe: function setElementDatasetValueSafe(selector) {
        var dataSetPropertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
        var propertyValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        var element = document.querySelector(selector);
        if (!element) return null;
        element.dataset[dataSetPropertyName] = propertyValue;
        return element;
    },
    setListenerSafe: function setListenerSafe(selector, delegate) {
        var eventType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'click';

        var element = document.querySelector(selector);
        if (!element) return null;
        element.addEventListener(eventType, delegate);
        return element;
    },
    setClassSafe: function setClassSafe(selector, className, isRemove) {
        var element = document.querySelector(selector);
        if (!element) return null;

        if (isRemove) element.classList.remove(className);else element.classList.add(className);
    },
    removeClassSafe: function removeClassSafe(selector, className) {
        var element = document.querySelector(selector);
        if (!element) return null;
        element.classList.remove(className);
    },

    findDeliveryRefSafe: function findDeliveryRefSafe(cart, key) {
        if (!cart || !cart.constants) return '';
        var constantObject = cart.constants.find(function (i) {
            return i.key === key;
        });
        if (!constantObject) return '';
        return constantObject.value;
    },
    reverseString: function reverseString(str) {
        return str.split("").reverse().join("");
    },

    addRemoveClass: function addRemoveClass(selector, className, isAdd) {
        var errorOnNoElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

        var element = document.querySelector(selector);
        if (!element) {
            if (errorOnNoElement) console.error('Error in common/addRemoveClass', { selector: selector, className: className, isRemove: isAdd });
            return;
        }
        if (isAdd) element.classList.add(className);else element.classList.remove(className);
    },
    convertIntSafe: function convertIntSafe(value) {
        if (!value || typeof value !== 'string') return 0;
        return (/^-?[0-9]{1,10}$/.test(value) ? parseInt(value) : 0
        );
    },
    roundToDecimalPlaces: function roundToDecimalPlaces(value) {
        var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        try {
            if (typeof value !== 'number') {
                console.error('Passed value: \'' + value + '\' is not a number, which can be rounded.');
                return value;
            }
            var multiplier = Math.pow(10, decimalPlaces);
            return Math.round(value * multiplier) / multiplier;
        } catch (e) {
            console.error('Error rounding to specified decimal places of passed value: \'' + value + '\'.', e);
            return value;
        }
    },
    updateValidityView: function updateValidityView(validationText, validatedElement, additionalClass) {
        var warningElement = validatedElement.parentElement.querySelector('.field-validation-error');
        // empty text or null means validation passed, if text is present, processing continues
        if (!validationText) {
            validatedElement.classList.remove('input-validation-error');
            if (warningElement) warningElement.parentElement.removeChild(warningElement);
            return;
        }

        // show result in case of validation text is present
        if (warningElement) {
            warningElement.textContent = validationText;
        } else {
            common.createElement('span', validatedElement.parentElement, {
                className: 'field-validation-error text-danger ' + additionalClass, textContent: validationText
            });
        }
        validatedElement.classList.add('input-validation-error');
    },

    registerRegexValidation: function registerRegexValidation(element, pattern, validationMessage) {
        if (!element) {
            console.warn('Element assigned for validation (registerRegexValidation) has empty element: ' + element);
            return;
        }
        pattern = pattern || element.dataset.valRegexPattern;
        if (!pattern) {
            console.warn('Element assigned for validation has empty pattern: ' + pattern);
            return;
        }

        element.addEventListener('keyup', function (event) {
            try {
                var regex = new RegExp(pattern);
                var isInvalid = element.dataset.isInvalid = !regex.test(element.value);
                var _message = isInvalid ? validationMessage || element.dataset.msg : null;
                // create element and set class
                common.updateValidityView(_message, element);
            } catch (e) {
                console.error('Error in validation (registerRegexValidation). Element: ' + element + ', pattern: ' + pattern);
            }
        });
    },
    keepJustNumbers: function keepJustNumbers(value) {
        var regex = new RegExp('[^0-9]', 'g');
        var regexPrefix = new RegExp('^42[01]', 'g');
        var nineNumbersRegex = new RegExp('[1-9][0-9]{0,8}');
        var newValue = (value || '').replace(regex, '').replace(regexPrefix, '');
        return (nineNumbersRegex.exec(newValue) || []).pop() || '0';
    },
    registerPhoneNumberValidation: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'keyup';
            var phoneInputSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.phone-number-restricted';

            var phoneInputs, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, phoneInput;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            phoneInputs = document.querySelectorAll(phoneInputSelector);
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context.prev = 4;
                            _iterator2 = (0, _getIterator3.default)(phoneInputs);

                        case 6:
                            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                _context.next = 15;
                                break;
                            }

                            phoneInput = _step2.value;

                            if (!(phoneInput.alreadyRegisteredKeyup === true)) {
                                _context.next = 10;
                                break;
                            }

                            return _context.abrupt('return');

                        case 10:
                            phoneInput.addEventListener(eventName, function (event) {
                                event.target.value = common.keepJustNumbers(event.target.value);
                                console.debug('KEYUP event', event.target.value);
                            });
                            phoneInput.alreadyRegisteredKeyup = true;

                        case 12:
                            _iteratorNormalCompletion2 = true;
                            _context.next = 6;
                            break;

                        case 15:
                            _context.next = 21;
                            break;

                        case 17:
                            _context.prev = 17;
                            _context.t0 = _context['catch'](4);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context.t0;

                        case 21:
                            _context.prev = 21;
                            _context.prev = 22;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 24:
                            _context.prev = 24;

                            if (!_didIteratorError2) {
                                _context.next = 27;
                                break;
                            }

                            throw _iteratorError2;

                        case 27:
                            return _context.finish(24);

                        case 28:
                            return _context.finish(21);

                        case 29:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[4, 17, 21, 29], [22,, 24, 28]]);
        }));

        return function registerPhoneNumberValidation() {
            return _ref.apply(this, arguments);
        };
    }(),
    isMobile: function isMobile() {
        var userAgent = navigator.userAgent || window.opera;

        // Check for mobile phones
        if (/android/i.test(userAgent)) {
            // Android device
            return !/tablet/i.test(userAgent);
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            // iOS device
            return !/iPad/i.test(userAgent);
        }
        // Other mobile devices
        return (/Mobile|mini|Fennec|Android|iP(ad|od|hone)|BlackBerry|IEMobile|Silk|Opera Mini|Windows Phone/.test(userAgent)
        );
    },
    isTablet: function isTablet() {
        var userAgent = navigator.userAgent || window.opera;

        // Check for tablets
        if (/android/i.test(userAgent)) {
            // Android device
            return (/tablet/i.test(userAgent)
            );
        }
        if (/iPad/.test(userAgent) && !window.MSStream) {
            // iPad
            return true;
        }
        // Other tablets
        return (/Tablet|iPad|PlayBook|Nexus 7|Nexus 10|KFAPWI/.test(userAgent)
        );
    },
    getCustomerDetails: function getCustomerDetails() {
        try {
            var _elementId = 'customerInfoElement';
            var customerInfoElement = document.getElementById(_elementId);
            if (!customerInfoElement) return {};

            return (0, _extends3.default)({}, customerInfoElement.dataset, { customer: customerInfoElement.value });
        } catch (e) {
            console.error('Error getting customer details from page element \'' + elementId + '\'.', e);
            return {};
        }
    }
};

exports.default = common;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/common.js
// module id = 38
// module chunks = 0 1 2